import React from "react";
import { Send, ArrowRight } from "lucide-react";
import { useSettings } from "@/hooks/useSettings";
import { useCommunityLinks } from "@/hooks/useCommunityLinks";
import api from "@/lib/api";

// Reusable Telegram announcement. Shows nothing until either a coming-soon teaser
// or a LIVE state (admin-enabled AND an enabled Telegram link with a URL exists).
export default function TelegramBanner() {
  const { data: settings } = useSettings();
  const { data: links = [] } = useCommunityLinks();
  const tg = links.find((l) => l.platform === "telegram");
  const live = !!settings?.telegramLive && tg && (tg.url || "").trim();

  if (live) {
    return (
      <a
        href={tg.url} target="_blank" rel="noreferrer"
        onClick={() => api.post("/analytics/event", { name: "official_link_click", meta: { id: "telegram" } }).catch(() => {})}
        data-testid="telegram-banner-live"
        className="group flex items-center justify-between gap-4 comic-card p-4 sm:p-5 bg-ink3 hover:border-neon transition-colors">
        <div className="flex items-center gap-3">
          <span className="w-11 h-11 grid place-items-center bg-neon text-black border-3 border-black shrink-0"><Send className="w-5 h-5" /></span>
          <div>
            <p className="font-display font-900 uppercase text-neon text-sm leading-tight">Official Telegram Is Live</p>
            <p className="font-mono text-xs text-dim">Join the ROBBED community</p>
          </div>
        </div>
        <span className="btn-neon !py-2 !px-3 !text-xs shrink-0">Join <ArrowRight className="w-4 h-4" /></span>
      </a>
    );
  }
  // Coming soon teaser (no link, nothing clickable/broken)
  return (
    <div data-testid="telegram-banner-soon" className="flex items-center gap-3 comic-card p-4 sm:p-5">
      <span className="w-11 h-11 grid place-items-center bg-ink3 text-dim border-3 border-black shrink-0"><Send className="w-5 h-5" /></span>
      <div>
        <p className="font-display font-900 uppercase text-cream text-sm leading-tight">Telegram <span className="text-gold">Coming Soon</span></p>
        <p className="font-mono text-xs text-dim">The official ROBBED Telegram is on the way. Follow X for the drop.</p>
      </div>
    </div>
  );
}
